import { Loader, TableDataRequest, Card, BackButton, useIdFromRoute } from '@fl/cmsch-fe-library';
import React, { FC, useCallback, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { Opt } from 'ts-opt';
import { BreedingFemale } from 'api/gen/BreedingFemale';
import { Content } from 'app/content';
import * as routerActions from 'app/router';
import { useOurTranslation } from 'app/translations';
import { ConnectedScreenHeader } from 'common/layout';
import { replaceSpacesWithUnbreakableSpaces } from 'utils/replace-spaces-with-unbreakable-spaces';
import { CowBrowserTable } from '../components/cow-browser';
import { animalBrowserAction, simpleAnimalBrowserSelector } from '../model';
import { AnimalBrowserAction } from '../model/action';
interface DispatchProps {
  goTo(path: string): void;
  clearStableName(): void;
}
type Props = DispatchProps;
const CowBrowserBase: FC<Props> = props => {
  const stableInfo = useSelector(simpleAnimalBrowserSelector.stableInfo);
  const printInProgress = useSelector(simpleAnimalBrowserSelector.printInProgress);
  const exportInProgress = useSelector(simpleAnimalBrowserSelector.exportInProgress);
  const stableNameOpt = stableInfo.prop('code');
  const {
    t,
    tCommon
  } = useOurTranslation('animalBrowser');
  const dispatch = useDispatch();
  const id = useIdFromRoute();
  const {
    goTo,
    clearStableName
  } = props;
  const getCows = useCallback((tableDataRequest: Opt<TableDataRequest<BreedingFemale>>) => {
    dispatch(animalBrowserAction.getcowBrowserTableData(tableDataRequest, id));
  }, [dispatch, id]);
  const goBackToList = useCallback(() => {
    clearStableName();
    goTo('/animal-browser/stables');
  }, [goTo, clearStableName]);
  const cardTitle = useMemo(() => stableNameOpt.map(stableName => `${t('breedersOverviewInStable')}: ${replaceSpacesWithUnbreakableSpaces(stableName)}`).caseOf(title => <ConnectedScreenHeader title={title} />, () => <Loader show />), [stableNameOpt, t]);
  return <Content browserTabTitle={t('breedersBrowser')} data-sentry-element="Content" data-sentry-component="CowBrowserBase" data-sentry-source-file="cow-browser.tsx">
            <Card title={cardTitle} titleSize="medium" extra={<BackButton text={tCommon('backToList')} onClick={goBackToList} />} noWhiteSpaceBody data-sentry-element="Card" data-sentry-source-file="cow-browser.tsx">
                <CowBrowserTable printInProgress={printInProgress} exportInProgress={exportInProgress} getCows={getCows} data-sentry-element="CowBrowserTable" data-sentry-source-file="cow-browser.tsx" />
            </Card>
        </Content>;
};
const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  goTo: (path: string): void => void dispatch(routerActions.push(path)),
  clearStableName: (): AnimalBrowserAction => dispatch(animalBrowserAction.clearStableName())
});

/**
 * Renders the breeding-female browser for the stable selected on the overview screen.
 *
 * @returns The stable-specific breeding-female browser screen.
 */
export const CowBrowser = connect(null, mapDispatchToProps)(CowBrowserBase);